import moment from "moment";
import type { DonationLinkReviewItem } from "./DonationLinkReviewModal";

export type PortalOwnerType = "MASJID" | "ORGANIZATION" | "INDIVIDUAL";

export const REVIEW_PAGE_SIZE = 20;
export const REVIEW_FETCH_LIMIT = 100;
export const REVIEW_MAX_PAGES = 50;

export function formatTabCount(total: number): string {
  return Math.max(0, total).toString().padStart(2, "0");
}

export function matchesDonationSearch(
  row: Pick<
    DonationLinkReviewItem,
    "title" | "entityId" | "entityType" | "entityName" | "customPaymentLink" | "createdAt"
  >,
  query: string
): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;

  const created = row.createdAt
    ? moment.utc(row.createdAt).local().format("DD-MMM-YYYY HH:mm:ss")
    : "";

  return (
    row.title?.toLowerCase().includes(q) ||
    row.entityId?.toLowerCase().includes(q) ||
    row.entityType?.toLowerCase().includes(q) ||
    row.entityName?.toLowerCase().includes(q) ||
    row.customPaymentLink?.toLowerCase().includes(q) ||
    created.toLowerCase().includes(q)
  );
}

/** Walk GraphQL pages until a short page. Backend max page size is 100. */
export async function fetchAllPages<T>(
  fetchPage: (page: number, limit: number) => Promise<T[]>,
  pageLimit = REVIEW_FETCH_LIMIT
): Promise<T[]> {
  const all: T[] = [];
  let page = 1;
  while (true) {
    const rows = await fetchPage(page, pageLimit);
    all.push(...rows);
    if (rows.length < pageLimit || page >= REVIEW_MAX_PAGES) break;
    page += 1;
  }
  return all;
}

/** Donation entityType is stored lowercase; portal redirect expects MASJID | ORGANIZATION | INDIVIDUAL. */
export function portalOwnerTypeFromEntity(
  entityType: string | null | undefined
): PortalOwnerType | null {
  switch ((entityType || "").trim().toUpperCase()) {
    case "MASJID":
      return "MASJID";
    case "ORGANIZATION":
      return "ORGANIZATION";
    case "INDIVIDUAL":
      return "INDIVIDUAL";
    default:
      return null;
  }
}
